angular.module("filterTableContractSign.components",[])
.component("filterTableContractSign",{
    templateUrl: "ng/components/filterTableContractSign/filterTableContractSign.view.html",
    bindings:{
        exportFilter: '&'
    },
    controller: FilterTableContractSignController,
    controllerAs: "filterTableContractSignCtrl"
})

function FilterTableContractSignController(
    $contractService
){

    var self = this;

    self.$onInit = function(){
        self.$contractService= $contractService;
        self.filter={
            numeroContratto: null
            
        }
    }

    self.search = function(){

        self.exportFilter({filter: self.filter});
        self.filter={};
    }
}